import { render, staticRenderFns } from "./MyScore.vue?vue&type=template&id=1c8ae9c7&scoped=true&"
import script from "./MyScore.vue?vue&type=script&lang=js&"
export * from "./MyScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8ae9c7",
  null
  
)

export default component.exports